import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthenticationService } from './../../shared/authentication.service';
import { QuestionService } from './../../shared/questionService';
import { TicketService } from '../../shared/ticketService';
import { AddqualitynotesComponent } from '../addqualitynotes/addqualitynotes.component';

@Component({
  selector: "app-disputedetailswithquestioninfo",
  templateUrl: "./disputedetailswithquestioninfo.component.html",
  styleUrls: ["./disputedetailswithquestioninfo.component.scss"]
})

export class DisputedetailswithquestioninfoComponent implements OnInit {
  
  constructor(public dialogRef: MatDialogRef<DisputedetailswithquestioninfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public questionService: QuestionService,
    public auth: AuthenticationService,
    public ticketService: TicketService) { 

  }

  ngOnInit() {

  }

  OnCloseConfirm() {
    this.dialogRef.close('Confirm');
  }

  addNotes() {
    let qualityNotesDialog = this.dialog.open(AddqualitynotesComponent, {
      width: '500px',
      data: {
        IsDispute: true,
        QuestionId: this.data.QuestionId,
        QATicketActivityId: this.data.QATicketActivityId,
        IsDisputeComplete: this.data.IsDisputeComplete
      }
    });
    qualityNotesDialog.afterClosed().subscribe(result => {
      if (result === 'cancel') {
        return;
      }
      if (result !== 'cancel') {
        if (result.activity === 'disputecomplete') {
          
          this.questionService.addQualityNotesAndUpdateDisputeActivity(this.ticketService.ticket.qaTicketId, this.auth.username, result.subject, result.message, 'dispute', result.questionid, result.qaticketactivityid, this.auth.currentState, this.auth.token).subscribe(res => {
            
            this.data.disputes = res;
          });
        }
        else if (result.activity === 'disputeaddnotes') {
          
          this.questionService.addDisputeNotes(this.ticketService.ticket.qaTicketId, this.auth.username, result.subject, result.message, 'dispute', result.questionid, result.qaticketactivityid, this.auth.currentState, this.auth.token).subscribe(res => {
            
            this.data.disputes = res;
          });
        }
      }
    });
  }
}
